module.exports = __webpack_public_path__ + "static/media/logo-footer.fec057e8.svg";